import React from 'react';
import ReactEchartsCore from 'echarts-for-react/lib/core';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/title';

import 'echarts/lib/chart/bar';

import NHFetch from '../../utils/NHFetch.js';

const yxxtBasicUrl = 'api/zhxg-yxxt'; //迎新管理服务后台接口基础路径
const errMaxCount = 3; // 请求异常最大次数
const speed = 30 * 1000; //轮询时间间隔
const pageSize = 5; //分页显示每页数据数量

/**
 * 各专业报到统计面板
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-06-29
 * Version: 1.0
 * Modify log:
 */
export default class _BarBox1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errCount: 0, //连续请求错误次数
            barData: [], //各专业报到统计数据
            page: 0, //当前显示的页数
            activeBarData: [] //当前显示的数据
        };

        this.polling;
        this.activePolling;
    }

    componentDidMount() {
        this.getData();
    }

    // 组件卸载时清除定时器
    componentWillUnmount() {
        if (this.polling) {
            clearTimeout(this.polling);
        }
        if (this.activePolling) {
            clearInterval(this.activePolling);
        }
    }

    /**
     * * 获取各专业报到统计数据
     * @memberof _BarBox1
     */
    getData = () => {

        NHFetch(yxxtBasicUrl + '/sstj/getStatisticsForProfessionalReported', 'GET')
            .then(res => {
                if (res && res.data) {
                    this.polling = setTimeout(() => {
                        this.getData();
                    }, speed);

                    let data = res.data;
                    let barData = [];
                    let pageItems = [];

                    //如果数据量超过每页最大显示数量，则做分页显示处理
                    data.map((item, index) => {

                        pageItems.push(item);

                        if ((index + 1) % pageSize == 0 || index == data.length - 1) {
                            barData.push(pageItems);
                            pageItems = [];
                        }
                    });

                    this.setState({ errCount: 0, barData: barData, activeBarData: barData[0] }, () => {

                        if (this.activePolling) {
                            clearInterval(this.activePolling);
                        }

                        //隔5秒换页
                        this.activePolling = setInterval(() => {
                            let { page, barData } = this.state;
                            const length = barData.length;

                            if (page + 1 >= length) {
                                page = 0;
                            } else {
                                page += 1;
                            }
                            let activeBarData = barData[page];

                            this.setState({ page, activeBarData });
                        }, 5000);
                    });

                }
            }).catch(err => {
                let errCount = this.state.errCount;
                //如果请求异常次数未超过最大次数限制，则继续尝试
                if (errCount < errMaxCount) {
                    this.polling = setTimeout(() => {
                        this.getData();
                    }, speed);
                    this.setState({ errCount: errCount + 1 });
                } else {
                    //异常超过3次后终止轮询
                    if (this.polling) {
                        clearTimeout(this.polling);
                    }
                    if (this.activePolling) {
                        clearInterval(this.activePolling);
                    }

                }
            });
    };

    /**
     * * 构造专业报到率条形统计图
     * @memberof _BarBox1
     */
    getBarOption = () => {
        const { rem } = this.props;
        const { activeBarData = [] } = this.state;

        // y轴系列（专业名称）
        let college = activeBarData.map(item => {
            return item.zymc;
        });

        //报到人数
        let bdrs = activeBarData.map(item => {
            return item.bdrs;
        });

        //报到率
        let bdl = activeBarData.map(item => {
            return item.bdl;
        });

        //未报到人数
        let wbdrs = activeBarData.map(item => {
            return item.wbdrs;
        });

        //未报到率
        let wbdl = activeBarData.map(item => {
            return item.wbdl;
        });

        const option = {
            title: {
                text: '各专业报到统计',
                textStyle: {
                    color: '#05ffe3',
                    fontSize: 0.18 * rem
                }
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    // 坐标轴指示器，坐标轴触发有效
                    type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                },
                formatter: '{a0}: {c0}%<br />{a1}: {c1}%'
            },
            legend: {
                data: ['已报到', '未报到'],
                top: '4%',
                itemWidth: 0.25 * rem,
                itemHeight: 0.14 * rem,
                textStyle: {
                    color: '#fff',
                    fontSize: 0.18 * rem
                }
            },
            grid: {
                top: '8%',
                left: '1%',
                right: '10%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: {
                type: 'value',
                interval: 50,
                max: 100,
                axisLabel: {
                    formatter: function (value) {
                        return value + '%';
                    },
                    show: true,
                    color: '#fff',
                    fontSize: 0.14 * rem
                },
                axisLine: {
                    lineStyle: {
                        color: '#fff'
                    }
                },
                splitLine: {
                    show: true,
                    interval: 50,
                    lineStyle: {
                        color: '#fff',
                        opacity: 0.2
                    }
                }
            },
            yAxis: {
                type: 'category',
                axisLabel: {
                    show: true,
                    color: '#fff',
                    fontSize: 0.14 * rem,
                    formatter: (value, index) => {

                        //专业名字过长时，超过7个字则换行
                        let titleStr = [];
                        if (value.length > 0) {
                            let count = parseInt(value.length / 7) + 1;
                            for (let i = 0; i < count; i++) {
                                titleStr.push(value.substr(i * 7, 7));
                            }
                        }

                        return titleStr.length > 1 ? titleStr.join('\n') : titleStr.join("");
                    },
                },
                axisLine: {
                    lineStyle: {
                        color: '#fff'
                    }
                },
                data: college
            },
            series: [
                {
                    name: '已报到',
                    type: 'bar',
                    barMaxWidth: 0.24 * rem,
                    stack: '总量',
                    barCategoryGap: '40%',
                    label: {
                        normal: {
                            formatter: function (data) {
                                return bdrs[data.dataIndex];
                            },
                            show: true,
                            fontSize: 0.14 * rem,
                            position: 'insideLeft'
                        }
                    },
                    itemStyle: {
                        normal: {
                            color: {
                                type: 'bar',
                                colorStops: [
                                    {
                                        offset: 0,
                                        color: '#267ef8' // 0% 处的颜色
                                    },
                                    {
                                        offset: 1,
                                        color: '#02ede2' // 100% 处的颜色
                                    }
                                ],
                                globalCoord: false // 缺省为 false
                            },
                            borderType: 'solid',
                            borderWidth: 1,
                            borderColor: '#fff'
                        }
                    },
                    data: bdl.map((item, index) => {
                        return ((item == 0 || item == 1)? item*100 : parseFloat(item * 100).toFixed(2));
                    })
                },
                {
                    name: '未报到',
                    type: 'bar',
                    barMaxWidth: 0.24 * rem,
                    stack: '总量',
                    label: {
                        normal: {
                            formatter: function (data) {
                                return wbdrs[data.dataIndex];
                            },
                            show: true,
                            fontSize: 0.14 * rem,
                            position: 'insideRight'
                        }
                    },
                    itemStyle: {
                        normal: {
                            color: '#8ea6c1',
                            borderType: 'solid',
                            borderWidth: 1,
                            borderColor: '#fff'
                        }
                    },
                    data: wbdl.map((item, index) => {
                        return ((item == 0 || item == 1)? item*100 : parseFloat(item * 100).toFixed(2));
                    })
                }
            ]
        };

        return option;
    };
    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <ReactEchartsCore
                    style={{ width: '100%', height: '100%' }}
                    echarts={echarts}
                    option={this.getBarOption()}
                    notMerge={true}
                    lazyUpdate={true}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./containers/Show-bgy/_BarBox1.js